module.exports = __webpack_public_path__ + "img/icon_contact.87683b4b.svg";